import { AddMassMailing } from '~/features/MassMailing/AddMassMailing'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'

const breadcrumbs: BreadcrumbsList = [
  { title: 'Уведомления', link: '/mass-mailing' },
  { title: 'Создание уведомления' },
]

export const AddMassMailingPage = () => {
  return (
    <PageContainer title='Создание уведомления'>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} />
        <PageTitle>Новое уведомление</PageTitle>
      </Container>
      <AddMassMailing />
    </PageContainer>
  )
}
